<template>
    <div class="tag-container">
        <span v-show="hasTags" class="icon icon-100 icon-glyphicons-basic-tags icon-mr"></span>
        <span v-for="(tag, index) in tags" :key="tag.id" class="category-link-span">
            <router-link :to="categoryLinkObj(tag.category)" class="category-link font-weight-500">{{
                tag.category.name
            }}</router-link>
            <span v-if="index < tags.length - 1">,</span>
        </span>
    </div>
</template>

<script>
export default {
    name: "CommunityCategoryTags",
    props: {
        tags: {
            type: Array,
            required: true,
        },
    },
    computed: {
        hasTags() {
            if (!this.tags) {
                return false
            }
            return this.tags.length > 0
        },
    },
    methods: {
        categoryLinkObj(category) {
            return {
                name: "CommunityLibrary",
                query: {
                    tag: category.name,
                },
            }
        },
    },
}
</script>

<style lang="scss" scoped>
@import "@/assets/styles/variables.scss";
@import "@/assets/styles/community.scss";

.tag-container {
    font-size: 14px;
}

.category-link-span {
    padding-right: 6px;
}
</style>